import { Button } from '../../../../../../components/button/button';
import { Modal, ModalProps } from '../../../../../../components/modal/modal';
import { useDeleteExternalReviewModal } from './use-delete-external-review-modal';
import s from './create-external-review-modal.module.css';

export const DeleteExternalReviewModal = (props: ModalProps) => {
  const { t, handleDelete, isLoading, reviewUrl } = useDeleteExternalReviewModal(props);

  return (
    <Modal {...props} title={t('Удалить внешний источник')} className={s.feature}>
      <label>
        {t('Вы действительно хотите удалить внешний источник {{url}}?', { url: reviewUrl })}
      </label>
      <div className={s.controls}>
        <Button variant="secondary" onClick={props.onClose} disabled={isLoading}>
          {t('Отменить')}
        </Button>
        <Button variant="danger" onClick={handleDelete} disabled={isLoading}>
          {t('Удалить')}
        </Button>
      </div>
    </Modal>
  );
};
